export default {
  state: {
    nome: '',
    usuario: '',
    token: ''
  },

  mutations: {
    setUser: (state, user) => {
      state.user = user
    }
  },

  gettters: {
    gerUser: state => state.user
  }
}



// WEBPACK FOOTER //
// ./src/store/storeUser.js